import { validate, submit } from '../../../assets/src/js/utils';

export default class ApplicationForm {
    constructor(rootNode) {
        this.$refs = {
            rootNode,
            form: document.querySelector('form'),
            inputs: document.querySelectorAll('input, textarea, select'),
            alert: rootNode.querySelector('.alert-anchor'),
            checkOnChange: false
        };

        this.$refs.rootNode.addEventListener('change', validate.bind(this))
        this.$refs.rootNode.addEventListener('submit', submit.bind(this))

        this.setupCaptchaListener();

        // Scroll to alert
        if(this.$refs.alert) {
            this.$refs.alert.scrollIntoView()
        }
    }

    setupCaptchaListener(){
        const button = this.$refs.form.querySelector('button[type="submit"]');
        button.setAttribute('disabled', '');

        this.$refs.form.querySelector('altcha-widget').addEventListener('statechange', (e) => {
            const state = e.detail.state;

            if(state === 'verified'){
                button.removeAttribute('disabled');
            }else{
                button.setAttribute('disabled', '');
            }
        })
    }
};
